import "styled-components/macro";

import { SimpleInterpolation } from "styled-components/macro";
import { IInputVariantEnums } from "../components/formElements";
export interface IColor {
  color: string;
  background: string;
  inverted: {
    color: string;
    background: string;
  };
}
export interface IFontWeight {
  normal: number;
  bold: number;
  bolder: number;
}
/**
 * Static values required to build a dynamic Theme
 */
export interface IThemeValues {
  branded: IBrandedValues;
  baseFontSize: number;
  fontWeight: IFontWeight;
  fontFamily: {
    headline: string;
    copy: {
      primary: string;
      secondary: string;
    };
  };
  webFontsConfig: {
    google?: { families: string[] };
    custom: {
      families: string[];
      urls: string[];
    };
    classes?: boolean;
  };
  colors: {
    global: IColors;
  };
  buttons: {
    default: { color: IColorStates; radius: string };
    primary: { color: IColorStates; radius: string };
    secondary: { color: IColorStates; radius: string };
    terminate: { color: IColorStates; radius: string };
    warning: { color: IColorStates; radius: string };
  };
  inputs: {
    //__typename: TypeNameEnums.THEME_OPTIONS_INPUT;
    default: {
      //__typename: TypeNameEnums.THEME_OPTIONS_INPUT_DEFAULT;
      borderColor: string;
      radius: string;
      invalidText: string;
      backgroundColor: string;
    };
  };
  // contentNav: { backgroundColor: string; color: string };
  // contentBody: { backgroundColor: string; color: string };

  component: {
    color: string;
    backgroundColor: string;
    header: {
      color: string;
      backgroundColor: string;
    };
    title: { color: string; backgroundColor: string; fontWeight: number };
    subTitle: { color: string; backgroundColor: string; fontWeight: number };
    content: { color: string; backgroundColor: string };
    borderColors: { basic: string };
  };
}

export interface IColorStates {
  //__typename: TypeNameEnums.THEME_OPTIONS_COLORS;
  base: IColor;
  hover: IColor;
  disabled: IColor;
}

export interface IColors {
  primary: {
    [key: string]: string;
  };
  secondary: {
    [key: string]: string;
  };
  greys: {
    [key: string]: string;
  };
  validation: {
    [key: string]: string;
  };
  diagram: {
    [key: string]: string;
  };
  overviewCharts: {
    [key: string]: string;
  };
}

export enum EProductEnums {
  PROTECT = "PROTECT",
  LITE = "LITE",
  CONTROL = "CONTROL",
  PRO = "PRO",
  QUICK = "QUICK",
  GOLD = "GOLD",
  CONSULT = "CONSULT",
}
export interface IBrandedLogoTypes {
  light: string;
  dark: string;
}

export type TLogo = Record<EProductEnums, IBrandedLogo>;

export interface IBrandedValues {
  //__typename: TypeNameEnums.THEME_OPTIONS_BRANDED;
  logo: TLogo;
  assets: {
    //__typename: TypeNameEnums.THEME_OPTIONS_ASSETS;
    background: string;
  };
  buttons: {
    //__typename: TypeNameEnums.THEME_OPTIONS_BUTTONS;
    default: {
      //__typename: TypeNameEnums.THEME_OPTIONS_BUTTONS_DEFAULT;
      color: IColorStates;
      radius: string;
    };
    primary: {
      //__typename: TypeNameEnums.THEME_OPTIONS_BUTTONS_PRIMARY;
      color: IColorStates;
      radius: string;
    };
    secondary: {
      //__typename: TypeNameEnums.THEME_OPTIONS_BUTTONS_SECONDARY;
      color: IColorStates;
      radius: string;
    };
  };
  inputs: Record<
    IInputVariantEnums,
    {
      //__typename: TypeNameEnums.THEME_OPTIONS_INPUT_DEFAULT;
      borderColor: string;
      radius: string;
      invalidText: string;
      backgroundColor: string;
    }
  >;
}

export interface IBreakPoints {
  mini: IBreakPointState;
  small?: IBreakPointState;
  medium?: IBreakPointState;
  large?: IBreakPointState;
  xlarge?: IBreakPointState;
  // wide?: IBreakPointState;
}

export interface IBreakPointState {
  basic?: SimpleInterpolation;
  portrait?: SimpleInterpolation;
  landscape?: SimpleInterpolation;
  retina?: SimpleInterpolation;
}

export interface IDevice {
  isMini: boolean;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isXLarge: boolean;
  // isWide: boolean;
  orientation: OrientationEnums;
  isPortrait: boolean;
  isLandscape: boolean;
  isRetina: boolean;
}

export enum LayoutEnums {
  SIMPLE, // ex: login page
  COMMON, // ex: dashboard
  SETUP, // ex: client management pages
  QUICK, // ex: quick dashboard
}
export enum PortraitBreakPointEnums {
  MINI = 0,
  SMALL = 375,
  MEDIUM = 768,
  LARGE = 1024,
  XLARGE = 1440,
  // WIDE = 1440,
}

export enum LandscapeBreakPointEnums {
  MINI = 0,
  SMALL = 812,
  MEDIUM = 1024,
  LARGE = 1366,
  XLARGE = 1920,
  // WIDE = 1920,
}

export enum OrientationEnums {
  LANDSCAPE = "landscape",
  PORTRAIT = "portrait",
}

/**
 * Extend ``DefaultTheme`` from ``styled-components`` to use internally as planContext
 * @ignore
 */
export declare module "styled-components/macro" {
  export declare class DefaultTheme {
    values: IThemeValues;
    branded: IBrandedValues;
    device: IDevice;
    layout: LayoutEnums;
    sideNavExpanded: boolean;
    rem(val: number): string;
  }
}
